var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "submit-tender clearfix",
      staticStyle: { display: "inline-block" },
    },
    [
      _c(
        "button",
        {
          class: _vm.className,
          attrs: {
            id: "submit_tender",
            disabled: _vm.disabled,
            type: "button",
          },
          on: {
            click: function ($event) {
              return _vm.init()
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("action.submit")))]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "chooseApprModal" + _vm.id,
          staticClass: "reveal choose-approver",
          attrs: { id: "chooseApprModal" + _vm.id },
        },
        [
          _c(
            "div",
            { staticClass: "modal-container" },
            [
              _c("p", { staticClass: "confirm-header" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("tender.submit.popupTitle")) +
                    "?\n      "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }, [
                _c("div", { staticClass: "tender-font float-left clearfix" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("tender.submit.chooseApprover")) +
                      "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("HKLSelect", {
                staticClass: "submit-hkl-select",
                attrs: {
                  value: _vm.approverId || undefined,
                  options: _vm.approverHklOptions,
                  showSearch: true,
                  placeholder: "",
                },
                on: { change: _vm.onApproverChange },
              }),
              _vm._v(" "),
              _vm.apprErrHint
                ? _c(
                    "span",
                    { staticClass: "form-error is-visible appr-error-message" },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.apprErrHint) + "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row align-right nav_btn" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                attrs: { type: "button", "aria-label": "Close reveal" },
                on: {
                  click: function ($event) {
                    return _vm.closeApprModal()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { type: "submit" },
                on: {
                  click: function ($event) {
                    return _vm.submitTender()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.submit")))]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("Modal", { ref: "alertModal", attrs: { modalId: "alert-modal" } }, [
        _c("div", { attrs: { slot: "content" }, slot: "content" }, [
          _c("pre", { staticClass: "modal-pure-text" }, [
            _vm._v(_vm._s(_vm.$t("tender.submit.submitted"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
          _c(
            "button",
            {
              staticClass: "btn btn--orange",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.navHome()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("hint.okay")))]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }